
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-60 -40 240 160"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"-60","y":"-40","width":"100%","height":"100%","fill":"#fe0000"}}),_c('rect',{attrs:{"x":"-60","y":"-40","width":"50%","height":"50%","fill":"#000095"}}),_c('path',{attrs:{"id":"a","d":"M8 0L0 30-8 0l8-30M0 8l30-8L0-8l-30 8","fill":"#fff"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(30)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(60)"}}),_c('circle',{attrs:{"r":"17","fill":"#000095"}}),_c('circle',{attrs:{"r":"15","fill":"#fff"}})])
          )
        }
      }
    